import React from "react";
import { Row, Col, Button, Form, Divider, Input } from "antd";
import { Header } from "../../../../components/Landing/Header/haeder.view";
import { BannerGlobal } from "../../components/Banner";
import { Footer } from "../../../../components/Landing/Footer";
import { useNuevaContraseña } from "../../../../hooks/useNuevaContraseña";
import { ModalExitoso } from "./components/ModalExitoso";

export const NuevaContraseña = () => {
  const { modalExito, setModalExito, onFinish, onAceptar } = useNuevaContraseña();
  return (
    <>
      <Header />
      <BannerGlobal
        Title="Recuperar Contraseña"
        Description="Convocatoria de fomento y estímulos para el arte y la cultura"
      />
      <Form layout="vertical" name="recuperarcontraseña" autoComplete="off" onFinish={onFinish}>
        <div className="container-fluid2">
          <div className="row container-box-main">
            <div className="col-12 font-size-18px font-family-Montserrat-Regular">
              Recuperar Contraseña
            </div>
            <Divider />
            <div className="col-12 font-size-14px font-family-Montserrat-SemiBold">
              Ingrese sus datos y a continuación utilice el botón "Cambiar contraseña"
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-4 input-padding-right">
                  <Form.Item
                    label={
                      <div className="no-margin">
                        <div className="no-margin letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                          Número de identificación
                        </div>
                      </div>
                    }
                    name="numero_documento"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <Input size="large" />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-4 input-padding-left">
                  <Form.Item
                    label={
                      <div className="row">
                        <div className="col-12 letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                          Nueva contraseña
                        </div>
                      </div>
                    }
                    name="contraseña1"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      iconRender={(visible) =>
                        visible ? (
                          <div className="no-margin">
                            <div className="nor-margin font-size-12px">VER</div>
                          </div>
                        ) : (
                          <div className="no-margin">
                            <div className="no-margin font-size-12px">VER</div>
                          </div>
                        )
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-4 input-padding-left">
                  <Form.Item
                    label={
                      <div className="row">
                        <div className="col-12 letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                          Confirmar nueva contraseña
                        </div>
                      </div>
                    }
                    name="contraseña2"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      iconRender={(visible) =>
                        visible ? (
                          <div className="no-margin">
                            <div className="nor-margin font-size-12px">VER</div>
                          </div>
                        ) : (
                          <div className="no-margin">
                            <div className="no-margin font-size-12px">VER</div>
                          </div>
                        )
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 justify-content-flex-end">
                  <Button className="button-azul-radius" htmlType="submit" name="recuperarcontraseña">
                    CAMBIAR CONTRASEÑA
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <Footer className="container-footer-absolute" />
      <ModalExitoso visualizar={modalExito} setVisualizar={setModalExito} onAceptar={onAceptar} />
    </>
  );
};
